import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-2xl font-bold text-[#1a1a1a]" style={{ fontFamily: "'Outfit', sans-serif" }}>
      {title}
    </h2>
    <div className="space-y-3 text-gray-600 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      {children}
    </div>
  </section>
);

const TermsPage = () => {
  return (
    <div className="page-fade-in">
      <section className="bg-[#EEF8F2] text-[#1a1a1a] border-b border-[#42D78A]/20 py-20 md:py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-[#42D78A] text-sm tracking-[0.2em] uppercase mb-4 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            614 Shop Local
          </p>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Terms and Conditions
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Last updated June 14, 2026
          </p>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto space-y-10">
          <div className="rounded-2xl border border-gray-100 bg-gray-50 p-6">
            <p className="text-gray-600 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              These Terms and Conditions govern your use of the 614 Shop Local website, directory, account features, event listings, newsletter forms, and related services. By using the site, you agree to these terms.
            </p>
          </div>

          <Section title="About 614 Shop Local">
            <p>
              614 Shop Local is a local directory and community platform designed to connect shoppers, small businesses, and markets. We provide tools for discovering businesses, following markets, sharing events, and supporting local commerce.
            </p>
          </Section>

          <Section title="Accounts">
            <p>
              Businesses, markets, shoppers, and administrators may use account features. You are responsible for keeping your login access secure and for making sure the information you provide is accurate, current, and lawful.
            </p>
            <p>
              We may suspend, remove, or restrict access to accounts or listings if we believe they violate these terms, create risk for the platform, or contain inaccurate, misleading, harmful, or inappropriate content.
            </p>
          </Section>

          <Section title="Listings and User Content">
            <p>
              If you submit business, market, logo, schedule, event, description, social media, or contact information, you confirm that you have the right to provide it and allow us to display it on 614 Shop Local.
            </p>
            <p>
              You grant 614 Shop Local permission to host, display, format, edit for clarity, and share submitted content as needed to operate and promote the directory, events, and related platform features.
            </p>
          </Section>

          <Section title="Directory Accuracy">
            <p>
              We try to keep listings helpful and current, but we cannot guarantee that all business, market, event, schedule, location, pricing, or availability information is complete or accurate. Please confirm details directly with the listed business or market when needed.
            </p>
          </Section>

          <Section title="Fees and Subscriptions">
            <p>
              Business directory listings, market registration, and shopper profiles are currently offered for free unless otherwise stated. Optional paid features, premium tools, or subscription-based services may be introduced separately.
            </p>
            <p>
              If payment features are enabled, billing will be handled through the payment provider shown at checkout. You are responsible for reviewing pricing and subscription terms before completing payment.
            </p>
          </Section>

          <Section title="Acceptable Use">
            <p>
              You agree not to misuse the site, attempt unauthorized access, interfere with site operations, submit false or misleading information, upload harmful files, violate another person&apos;s rights, scrape the site without permission, or use the platform for unlawful activity.
            </p>
          </Section>

          <Section title="Third-Party Links and Services">
            <p>
              The site may link to third-party websites, social media pages, Discord, payment providers, email tools, and business or market websites. We are not responsible for third-party content, policies, services, or practices.
            </p>
          </Section>

          <Section title="No Warranty">
            <p>
              The site is provided as-is and as available. We do not guarantee uninterrupted access, error-free operation, specific results, or that every issue will be corrected immediately.
            </p>
          </Section>

          <Section title="Limitation of Liability">
            <p>
              To the fullest extent allowed by law, 614 Shop Local is not liable for indirect, incidental, special, consequential, or punitive damages related to your use of the site, listings, events, third-party links, or platform features.
            </p>
          </Section>

          <Section title="Changes to These Terms">
            <p>
              We may update these Terms and Conditions from time to time. Continued use of the site after changes are posted means you accept the updated terms.
            </p>
          </Section>

          <Section title="Contact Us">
            <p>
              Questions about these Terms and Conditions can be sent to{" "}
              <a href="mailto:hello@614shoplocal.com" className="font-bold text-[#1a1a1a] hover:text-[#42D78A]">
                hello@614shoplocal.com
              </a>
              .
            </p>
            <p>
              You can also reach us through the <Link to="/contact" className="font-bold text-[#1a1a1a] hover:text-[#42D78A]">contact page</Link>.
            </p>
          </Section>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
